module.exports = __webpack_public_path__ + "media/ibra11-3.ab6a92c9.mp3";